import sortBy from 'lodash-es/sortBy'

import { getCalendarGridItemsInDayOrder } from '../CalendarGrid.utils'

import { CALENDAR_GRID_DAY_POPOVER_ORDER_FALLBACK } from './CalendarGridDayPopover.constants'

function getCalendarGridDayPopoverItemOrder(item) {
  return item.popover?.order ?? CALENDAR_GRID_DAY_POPOVER_ORDER_FALLBACK
}

export function getCalendarGridDayPopoverItems(items) {
  return sortBy(
    getCalendarGridItemsInDayOrder(items),
    getCalendarGridDayPopoverItemOrder
  )
}

export function getCalendarGridDayPopoverCommonTagItem(items) {
  const [firstItem] = items

  const firstKindLabel = firstItem?.popover?.kindLabel

  const hasCommonKind = items.every(
    item => item.popover?.kindLabel === firstKindLabel
  )

  return firstKindLabel && hasCommonKind ? firstItem : null
}

export function getHasCalendarGridDayLoadSummary(dayLoad) {
  return Boolean(dayLoad?.summary)
}

export function getIsCalendarGridDayEmpty(items) {
  return items.length === 0
}
